import Konva from 'konva/src/Core';
import 'konva/src/Shapes/Rect';
import 'konva/src/Shapes/Text';
import PlacingComponent from 'placingEditor/placingComponent';

class DesignControl extends PlacingComponent {
    constructor(componentSize, text, placement) {
        super();

        const controlPadding = 3;
        this.placement = placement;
        this.controlBg = new Konva.Rect({
            width: componentSize,
            height: componentSize,
            fill: '#eaeaea'
        });

        this.controlText = new Konva.Text({
            width: componentSize,
            height: componentSize,
            padding: controlPadding,
            lineHeight: componentSize,
            text: text,
            fontSize: componentSize - (controlPadding * 2),
            fontFamily: 'FontAwesome',
            fill: 'black'
        });

        this.addKonvaNode(this.controlBg);
        this.addKonvaNode(this.controlText);
    }
}

export default DesignControl;



// WEBPACK FOOTER //
// ./src/placingEditor/design/designControl.js